/**
 * Types for GET /v1/securityGroups/assignedEmployees - Assigned Employees List (Paginated)
 */

import type { LC_PagedResult } from '@/api/shared/types';

// ===== Pagination Constants =====

export const ASSIGNED_EMPLOYEES_LIST_DEFAULT_PAGE_SIZE = 10;

// ===== Filter Types =====

export const ASSIGNED_EMPLOYEES_STATUS_FILTER = {
  ALL: 'all',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
} as const;

export type AssignedEmployeesStatusFilter =
  typeof ASSIGNED_EMPLOYEES_STATUS_FILTER[keyof typeof ASSIGNED_EMPLOYEES_STATUS_FILTER];

// ===== Transport Types (Backend DTOs) =====

export interface LC_AssignedEmployee {
  employeeTaxIdentificationNumber: string;
  employeeName: string;
  status: string;
  adminGroupsCount: number;
  memberGroupsCount: number;
  adminGroupNames: string[];
  memberGroupNames: string[];
}

export type LC_AssignedEmployeesListOut = LC_PagedResult<LC_AssignedEmployee>;

// ===== Domain Models (Internal) =====

export interface AssignedEmployee {
  rut: string;
  name: string;
  status: string;
  adminGroupsCount: number;
  memberGroupsCount: number;
  adminGroupNames: string[];
  memberGroupNames: string[];
}

export interface AssignedEmployeesListResult {
  items: AssignedEmployee[];
  totalRecords: number;
}

export interface AssignedEmployeesListFilters {
  page?: number;
  pageSize?: number;
  status?: AssignedEmployeesStatusFilter;
  searchText?: string;
  orderBy?: string | null;
  orderDirection?: string | null;
  [key: string]: string | number | undefined | null;
}
